import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '@': 'editingStakeholder',
  },
  variables: {
    stakeholderId: '?1',
  },
  subqueries: {
    editingStakeholder: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'stakeholderId',
          },
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      quantity: 1,
      selection: {
        '{}': {
          name: 'Edit Stakeholder',
          type: 'details',
          alias: 'edit.stakeholder.modal',
          watch: {
            '[]': [
              {
                '{}': {
                  alias: 'save.stakeholder',
                },
              },
            ],
          },
          content: {
            '{}': {
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Stakeholder ID',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!code',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderName',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Stakeholder Name',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!name',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'employee',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Employee Record',
                              type: {
                                '{}': {
                                  entityId: 'ent:!personnel:!employee',
                                  dimensionId: 'dim::!personnel',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!employee',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'jobTitleRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Job Title / Role',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'jobTitle',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'departmentFunction',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Department / Function',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'department',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'subdepartmentTeam',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Subdepartment / Team',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'subdepartment',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'managerLeader',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Manager / Leader',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'manager',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'projectTeam',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Project Team',
                              type: 'BOOL',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!is_project_team_member',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'projectRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Project Role',
                              type: {
                                '{}': {
                                  enumId: 'enum::!stakeholder_project_role',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!project_role',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'systemUserRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'System / User Role',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!system_user_role',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'degreeOfImpact',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Degree of Impact',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!degree_of_impact',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'influenceDecisionRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Influence / Decision Role',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!influence_decision_role',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'changeChampion',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Change Champion',
                              type: {
                                '{}': {
                                  enumId: 'enum::!stakeholder_change_champion',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!change_champion',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'engagementNeeded',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Engagement Needed',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_engagement_needed',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!engagement_needed',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'validationStatus',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Validation Status',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_validation_status',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!validation_status',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'understanding',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Understanding',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!understanding',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'perceivedAttitude',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Perceived Attitude',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_perceived_attitude',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!perceived_attitude',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'potentialConcernsRisks',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Potential Concerns / Risks',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!concerns_risks',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'supportNeeds',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Support Needs',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!support_needs',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'communicationAudience',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Communication Audience',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!comm_audience',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'trainingAudienceNeed',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Training Audience / Need',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_training_audience',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!training_audience_need',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'notesFollowUp',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Notes / Follow-Up',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!notes_follow_up',
                      },
                    },
                  },
                ],
              },
              onSave: {
                '{}': {
                  action: {
                    '{}': {
                      alias: 'save.stakeholder',
                    },
                  },
                  variables: {
                    '{}': {
                      stakeholderId: {
                        '@.': '!id',
                      },
                      stakeholderCode: '${field:code}',
                      stakeholderName: '${field:stakeholderName}',
                      stakeholderEmployee: '${field:employee}',
                      stakeholderProjectRole: '${field:projectRole}',
                      stakeholderProjectTeam: '${field:projectTeam}',
                      stakeholderSupportNeeds: '${field:supportNeeds}',
                      stakeholderNotesFollowUp: '${field:notesFollowUp}',
                      stakeholderUnderstanding: '${field:understanding}',
                      stakeholderChangeChampion: '${field:changeChampion}',
                      stakeholderDegreeOfImpact: '${field:degreeOfImpact}',
                      stakeholderSystemUserRole: '${field:systemUserRole}',
                      stakeholderEngagementNeeded: '${field:engagementNeeded}',
                      stakeholderValidationStatus: '${field:validationStatus}',
                      stakeholderPerceivedAttitude:
                        '${field:perceivedAttitude}',
                      stakeholderTrainingAudienceNeed:
                        '${field:trainingAudienceNeed}',
                      stakeholderCommunicationAudience:
                        '${field:communicationAudience}',
                      stakeholderInfluenceDecisionRole:
                        '${field:influenceDecisionRole}',
                      stakeholderPotentialConcernsRisks:
                        '${field:potentialConcernsRisks}',
                    },
                  },
                },
              },
            },
          },
        },
      },
      subqueries: {
        manager: {
          ref: {
            attr: 'attr:ent#!personnel_leaders#!relationship:!leader',
          },
          using: 'managerRelationship',
          target: 'ent:!personnel:!employee',
          quantity: 1,
          selection: {
            '@.': '!name',
          },
        },
        employee: {
          ref: {
            attr: 'attr:ent#!stakeholders#!stakeholder:!employee',
          },
          target: 'ent:!personnel:!employee',
        },
        jobTitle: {
          ref: {
            attr: 'attr:ent#!personnel#!employee:!job_title',
          },
          using: 'employee',
          target: 'ent:!job_titles:!job_title',
          quantity: 1,
          selection: {
            '@.': '!name',
          },
        },
        department: {
          ref: {
            attr: 'attr:ent#!personnel#!employee:!org',
          },
          using: 'employee',
          target: 'ent:!org:!subdept',
          quantity: 1,
          selection: {
            if: [
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-advancement',
                  ],
                },
                'Advancement',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-athletics',
                  ],
                },
                'Athletics',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-finance-and-treasury',
                  ],
                },
                'Finance and Treasury',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-information-technology',
                  ],
                },
                'Information Technology',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-undergraduate-financial-aid',
                  ],
                },
                'Undergraduate Financial Aid',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-school-of-engineering-and-applied-science',
                  ],
                },
                'School of Engineering and Applied Science',
              ],
              null,
            ],
          },
        },
        subdepartment: {
          ref: {
            attr: 'attr:ent#!personnel#!employee:!org',
          },
          using: 'employee',
          target: 'ent:!org:!subdept',
          quantity: 1,
          selection: {
            '@.': '!name',
          },
        },
        managerRelationship: {
          ref: {
            attr: 'attr:ent#!personnel_leaders#!relationship:!personnel',
          },
          using: 'employee',
          target: 'ent:!personnel_leaders:!relationship',
        },
      },
    },
  },
}
